import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Fab,
    List,
    ListItem,
    TextField,
    Typography,
    IconButton,
    useTheme,
    InputAdornment,
    useMediaQuery
} from '@mui/material';
// import logo from 'assets/imgLogo.png';
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import { useNavigate } from "react-router-dom";
import { ReactComponent as SearchIcon } from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as RightArrow } from "assets/PwC_Funct_Icons_ChevronRight_Outline_Black_RGB.svg"
import { ReactComponent as LeftArrow } from "assets/PwC_Funct_Icons_ChevronLeft_Outline_Black_RGB.svg"
import { ReactComponent as CommentIcon } from "assets/PwC_Funct_Icons_Comment_Fill_Black_RGB.svg";
import logo from "assets/images/pwc.svg";

const subtabsItems = {
    "Users": {
        localStorageTabKey: "usersTabIndex",
        items: [
            { label: "User List", path: "user-list", index: 0, databaseUrl: '/user/list', tags: ['database'] },
            { label: "Bulk Transactions", path: "bulk-transaction", index: 1, databaseUrl: '/user/bulk-transactions', tags: ['database'] },
            { label: "Role List", path: "role-list", index: 2, databaseUrl: '/user/role', tags: ['database'] },
            { label: "Assign Permission", path: "assign-permission", index: 3, databaseUrl: '/user/assign-permission', tags: ['database'] },
        ]
    },
    'Project Progress and Scheduling': {
        localStorageTabKey: "scheduleTabIndex",
        items: [
            { label: "Schedule", path: "schedule", index: 0, dashboardUrl: '?type=schedule', databaseUrl: '/key-schedule/all-schedule', tags: ['dashboard', 'database'] },
            { label: "Construction", path: "construction", index: 1, dashboardUrl: '?type=schedule', databaseUrl: '/construction/all', tags: ['dashboard', 'database'] },
            { label: "Milestone", path: "milestone", index: 2, dashboardUrl: '?type=schedule', databaseUrl: '/key-milestone/all-milestone', tags: ['dashboard', 'database'] },
            { label: "Engineering", path: "engineering", index: 3, dashboardUrl: '?type=schedule', databaseUrl: '/engineering/all-activities', tags: ['dashboard', 'database'] },
            { label: "Plant & Machinery", path: "pm", index: 4, dashboardUrl: '?type=schedule', databaseUrl: '/key-p&m/all-p&m', tags: ['dashboard', 'database'] },
            { label: "Manpower", path: "manpower", index: 5, dashboardUrl: '?type=schedule', databaseUrl: '/key-manpower/all-manpower', tags: ['dashboard', 'database'] },
            { label: "Monte Carlo Simulation", path: "manpower", index: 6, databaseUrl: '/monte-carlo-simulation/all-monte-carlo-simulation', tags: ['database'] },
            { label: "Bim Viewer", path: "manpower", index: 7, databaseUrl: '/bim-viewer/all-bim-viewer', tags: ['database'] },
        ]
    },
    'Project Cost Control': {
        localStorageTabKey: "costTabIndex",
        items: [
            { label: "Financial Progress", path: "financial-progress", index: 0, dashboardUrl: '?type=cost', databaseUrl: '/financial-progress/all', tags: ['dashboard', 'database'] },
            { label: "Payment Tracker", path: "payment-tracker", index: 1, dashboardUrl: '?type=cost', databaseUrl: '/payment-tracker/all', tags: ['dashboard', 'database'] },
            { label: "BOQ", path: "boq", index: 2, dashboardUrl: '?type=cost', databaseUrl: '/payment-tracker/all', tags: ['database'] },
        ]
    },
    'Contract and Procurement Lifecycle': {
        localStorageTabKey: "procurementTabIndex",
        items: [
            { label: "Vendor Performance Tracker", path: "vendor-performancetracker", index: 0, dashboardUrl: '?type=procurement', databaseUrl: '/vendor-performance-tracker/all', tags: ['dashboard', 'database'] },
            { label: "Procurement", path: "procurement", index: 1, dashboardUrl: '?type=procurement', databaseUrl: '/Procurement/all', tags: ['dashboard', 'database'] }
        ]
    },
    'Governance and Compliance': {
        localStorageTabKey: "riskTabIndex",
        items: [
            { label: "Issues", path: "issues", index: 0, dashboardUrl: '?type=risk', databaseUrl: '/key-issues/all-issue', tags: ['dashboard', 'database'] },
            { label: "Key Clearances", path: "key-clearances", index: 1, dashboardUrl: '?type=risk', databaseUrl: '/key-clearance/all-clearance', tags: ['dashboard', 'database'] },
            { label: "Risk", path: "risks", index: 2, dashboardUrl: '?type=risk', databaseUrl: '/key-risk/all-risk', tags: ['dashboard', 'database'] },
            { label: "Safety", path: "safety", index: 3, dashboardUrl: '?type=risk', databaseUrl: '/key-safety/all-safety', tags: ['dashboard', 'database'] },
            { label: "Quality", path: "quality", index: 4, dashboardUrl: '?type=risk', databaseUrl: '/key-quality/all-quality', tags: ['dashboard', 'database'] }
        ]
    },
    "Change Control & Claim Tracker": {
        localStorageTabKey: "claims-and-changeorderTabIndex",
        items: [
            { label: "Claims", path: "claims-and-changeorder", index: 0, dashboardUrl: '?type=claims-and-changeorder', databaseUrl: '/key-claims/all-claims', tags: ['dashboard', 'database'] },
            { label: "Change Order", path: "claims-and-changeorder", index: 0, dashboardUrl: '?type=claims-and-changeorder', databaseUrl: '/key-change-tracker/all-change-tracker', tags: ['dashboard', 'database'] }
        ]
    },
    "DPR": {
        localStorageTabKey: "dprTabIndex",
        items: [
            { label: "Quantity Dpr", path: "quantity-dpr", index: 0, databaseUrl: '/dpr/Quantity_list', tags: ['database'] },
            { label: "DPR P&M List", path: "dpr-p&m-list", index: 1, databaseUrl: '/dpr_pmList/PM_list', tags: ['database'] }
        ]
    },
    "Config & Settings": {
        localStorageTabKey: "configsettingsTabIndex",
        items: [
            { label: "Project Settings", path: "project-settings", index: 0, databaseUrl: '/project-settings/all-settings', tags: ['database'] },
            { label: "Norms", path: "norms", index: 1, databaseUrl: '/norms/all-norms', tags: ['database'] },
            { label: "Workflow Management", path: "workflow-management", index: 2, databaseUrl: '/workflow/all-workflow', tags: ['database'] },
            { label: "Data Metrics Management", path: "data-metrics-management", index: 3, databaseUrl: '/data-alert-management/all-data-alert-management', tags: ['database'] },
        ]
    },
    "Help": {
        localStorageTabKey: "helpTabIndex",
        items: [
            { label: "Feature List", path: "faq-for-feature-list", index: 0, databaseUrl: '/faq/feature-list', tags: ['database'] },
            { label: "Data Sets", path: "faq-for-data-sets", index: 1, databaseUrl: '/faq/data-sets', tags: ['database'] }
        ]
    },
};

const staticQAList = [
    {
        question: "When is the Handover planned for Project X?",
        answer: (projectName) =>
            `The Forecast completion for ${projectName} is dd/mm/yy. Currently the Project is seeing a cumulative delay of xx days.\n\nHere is the link to view the complete status of ${projectName} — [Link to Home]`,
    },
    {
        question: "What are the delays observed in Project X?",
        answer: () =>
            `The following activities are delayed:\n• Engineering (delayed by 540 days)\n• Construction (delayed by 190 days)`,
    },
    {
        question: "Are there any change orders submitted in Project X?",
        answer: () =>
            `Yes, there are total 11 Change orders submitted in Project X.\n\nHere is the link to view the status of all change orders.`,
    },
    {
        question: "What is the cost variance observed in Project X?",
        answer: () =>
            `The cost variance is 11.49 CR and the current EAC (Estimate at Completion) is INR 2460.08 CR from an earlier Budgeted cost of INR 2445.32 CR.`,
    },
    {
        question: "Are there any open Issues or Risks observed in Project X?",
        answer: () =>
            `Yes, currently there are 34 Open Issues and 29 Active Risks in Project X.\n\nHere is the link to view the Open Issues and Active Risks.`,
    }
];


export default function FloatingButtonWithAssistantDialog() {
    const navigate = useNavigate();
    const theme = useTheme();
    const listRef = useRef(null);
    const isMobile = useMediaQuery('(max-width:768px)');
    const { data: AllProjects = [], isLoading } = useGetAllProjectsQuery();
    const [open, setOpen] = useState(false);
    const [input, setInput] = useState('');
    const [step, setStep] = useState(0);
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedMainTab, setSelectedMainTab] = useState('');
    const [selectedSubTab, setSelectedSubTab] = useState(null);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [openQuestionIndex, setOpenQuestionIndex] = useState(null);

    useEffect(() => {
        if (step === 1 && listRef.current) {
            listRef.current.scrollTop = 0;
        }
    }, [step]);

    const getSortedProjects = () => {
        return [...(AllProjects?.data || [])].sort(
            (a, b) => new Date(b.createddate) - new Date(a.createddate)
        );
    };

    const handleClose = () => {
        setStep(0);
        setInput('');
        setSelectedProject(null);
        setSelectedMainTab('');
        setSelectedSubTab(null);
        setSelectedAnswer(null);
        setOpenQuestionIndex(null);
        setOpen(false);
    };
    const trimmedInput = input.trim().toLowerCase();
    const filteredProjects = getSortedProjects().filter(project =>
        project.project_name.toLowerCase().includes(trimmedInput)
    );
    const modulesList = ['Project Dashboard', 'My Work', 'File', 'Image Gallery', ...Object.keys(subtabsItems)];

    const submodules = subtabsItems[selectedMainTab]?.items || [];

    const filteredSubmodules = submodules.filter(sub =>
        sub.label.toLowerCase().includes(trimmedInput)
    );

    const getStep1SearchResultsWithTag = (tagInput) => {
        const input = tagInput.toLowerCase().trim();
        if (!input) return [];
        const tags = ['dashboard', 'database'];
        const results = [];
        const addedLabels = new Set();
        if ('dashboard'.includes(input)) {
            results.push({
                label: 'Project Dashboard',
                onClick: () => {
                    const projectId = selectedProject?.project_id;
                    handleClose();
                    window.location.href = `/projects/${projectId}?type=project-landing`;
                }
            });
        }
        // Add QA-based matches
        if (selectedProject) {
            staticQAList.forEach((qaItem, idx) => {
                if (qaItem.question.toLowerCase().includes(input)) {
                    results.push({
                        type: 'qa',
                        id: `qa-${idx}`,
                        label: qaItem.question,
                        index: idx,
                        onClick: () => {
                            setOpenQuestionIndex((prev) => (prev === idx ? null : idx)); // toggle open
                            setSelectedAnswer(qaItem.answer(selectedProject?.project_name || "Project X"));
                        }
                    });
                }
            });
        }
        Object.entries(subtabsItems).map(([mainModule, { items }]) => {
            const mainModuleLower = mainModule.toLowerCase();
            if (mainModuleLower.includes(input)) {
                results.push({
                    label: mainModule,
                    showArrow: true,
                    onClick: () => {
                        setSelectedMainTab(mainModule);
                        setStep(2);
                        setInput('');
                    }
                });
            }
            items.map(sub => {
                const labelLower = sub.label.toLowerCase();
                const pathLower = sub.path.toLowerCase();
                const tagMatched = sub.tags.some(tag => tag.includes(input));
                const labelMatch = labelLower.includes(input);
                const pathMatch = pathLower.includes(input);
                if (labelLower === mainModuleLower) return;
                if (tagMatched) {
                    if (addedLabels.has(`${mainModule}-${sub.label}`)) return;
                    addedLabels.add(`${mainModule}-${sub.label}`);
                    sub.tags.map(tag => {
                        if (tag.includes(input)) {
                            results.push({
                                label: (
                                    <>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {/* {mainModule} <ChevronRightIcon fontSize="small" /> {sub.label} <ChevronRightIcon fontSize="small" /> {tag} */}
                                            {mainModule}  <RightArrow style={{ height: "16px", width: "16px", fontWeight: 500, fill: "#555" }} />
                                            {sub.label} <RightArrow style={{ height: "16px", width: "16px", fontWeight: 500, fill: "#555" }} />{tag}
                                        </div>
                                    </>
                                ),
                                onClick: () => {
                                    const projectId = selectedProject?.project_id;
                                    const base = `/projects/${projectId}`;
                                    const tabKey = subtabsItems[mainModule]?.localStorageTabKey;
                                    const tabIndex = sub.index;
                                    if (tabKey != null && tabIndex != null) {
                                        localStorage.setItem(tabKey, tabIndex);
                                    }
                                    handleClose();
                                    window.location.href = tag === 'dashboard'
                                        ? `${base}${sub?.dashboardUrl}`
                                        : `${base}${sub?.databaseUrl}`;
                                }
                            });
                        }
                    });
                }
                else if (labelMatch || pathMatch) {
                    results.push({
                        label: (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    {/* {mainModule} <ChevronRightIcon fontSize="small" /> {sub.label} */}
                                    {mainModule} <RightArrow style={{ height: "16px", width: "16px", fontWeight: 500, fill: "#555" }} /> {sub.label}
                                </div>
                            </>
                        ),
                        onClick: () => {
                            const tabKey = subtabsItems[mainModule]?.localStorageTabKey;
                            const tabIndex = sub.index;
                            if (tabKey != null && tabIndex != null) {
                                localStorage.setItem(tabKey, tabIndex);
                            }
                            setSelectedMainTab(mainModule);
                            setSelectedSubTab(sub);
                            setStep(3);
                            setInput('');
                        }
                    });
                }

            });
        });
        return results;
    };

    const getStep2SearchResultsWithTag = (tagInput) => {
        const input = tagInput.toLowerCase().trim();
        if (!input) return [];
        const tags = ['dashboard', 'database'];
        let matchedTags;
        if (input.length <= 2) {
            matchedTags = tags;
        } else {
            matchedTags = tags.filter(tag => tag.includes(input));
            if (matchedTags.length === 0) {
                matchedTags = [];
            }
        }
        const items = subtabsItems[selectedMainTab]?.items || [];
        const results = [];
        const addedLabels = new Set();
        if (selectedProject) {
            staticQAList.forEach((qaItem, idx) => {
                if (qaItem.question.toLowerCase().includes(input)) {
                    results.push({
                        type: 'qa',
                        id: `qa-${idx}`,
                        label: qaItem.question,
                        index: idx,
                        onClick: () => {
                            setOpenQuestionIndex((prev) => (prev === idx ? null : idx)); // toggle open
                            setSelectedAnswer(qaItem.answer(selectedProject?.project_name || "Project X"));
                        }
                    });
                }
            });
        }
        items.map(sub => {
            const labelLower = sub.label.toLowerCase();
            const pathLower = sub.path.toLowerCase();
            const tagMatch = matchedTags.length > 0 && matchedTags.some(tag => sub.tags.includes(tag));
            const labelMatch = labelLower.includes(input) || pathLower.includes(input);
            const labelKey = sub.label;
            if (tagMatch && !addedLabels.has(labelKey)) {
                matchedTags.map(tag => {
                    if (sub.tags.includes(tag)) {
                        addedLabels.add(labelKey);
                        results.push({
                            label: (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        {/* {sub.label} <ChevronRightIcon fontSize="small" /> {tag} */}
                                        {sub.label} <RightArrow style={{ height: "16px", width: "16px", fontWeight: 500, fill: "#555" }} /> {tag}
                                    </div>
                                </>
                            ),
                            onClick: () => {
                                const projectId = selectedProject?.project_id;
                                const base = `/projects/${projectId}`;
                                const tabKey = subtabsItems[selectedMainTab]?.localStorageTabKey;
                                const tabIndex = sub.index;

                                if (tabKey != null && tabIndex != null) {
                                    localStorage.setItem(tabKey, tabIndex);
                                }
                                handleClose();
                                window.location.href = tag === 'dashboard'
                                    ? `${base}${sub?.dashboardUrl}`
                                    : `${base}${sub?.databaseUrl}`;
                            }
                        });
                    }
                });
            }
            if (matchedTags.length === 0 && labelMatch && !addedLabels.has(labelKey)) {
                addedLabels.add(labelKey);
                results.push({
                    label: sub.label,
                    onClick: () => {
                        setSelectedSubTab(sub);
                        setStep(3);
                        setInput('');
                    }
                });
            }
        });
        return results;
    };

    const step3Options = [
        ...(selectedSubTab?.dashboardUrl ? ['Dashboard'] : []),
        ...(selectedSubTab?.databaseUrl ? ['Database'] : []),
    ];

    const filteredStep3Options = step3Options.filter(option =>
        option.toLowerCase().includes(trimmedInput)
    );
    useEffect(() => {
        if (open && listRef.current) {
            const inputElem = listRef.current.querySelector('input');
            if (inputElem) inputElem.focus();
        }
    }, [open]);

    return (
        <>
            {!open && (
                <Fab
                    onClick={() => setOpen(true)}
                    sx={{
                        position: 'fixed',
                        bottom: 15,
                        right: 30,
                        zIndex: 1300000,
                        color: "#FFFF",
                        height: '45px',
                        width: '45px',
                        backgroundColor: `${theme?.customSettings?.themeColor}`,
                        '&:hover': {
                            backgroundColor: `${theme?.customSettings?.themeColor}`,
                            color: "#FFFF"
                        }
                    }}
                >
                    {/* <SmartToyIcon sx={{ color: '#fff' }} /> */}
                    <CommentIcon style={{ width: "30px", height: "30px", fill: '#fff' }} />
                </Fab>
            )}
            {open && (
                <Box
                    sx={{
                        position: 'fixed',
                        bottom: 20,
                        right: { xs: 0, sm: 30 },
                        width: { xs: '100%', sm: '400px' },
                        height: '550px',
                        background: 'linear-gradient(140deg, #ff6726 30%, #FF6828 15%, #FFFF 65%)',
                        borderRadius: '16px',
                        boxShadow: '0px 2px 16px rgba(0,0,0,0.2)',
                        zIndex: 1300001,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: "10px", ml: "5px" }}>
                            {/* <img src={logo} alt="Logo" style={{ height: '51px', width: "97px" }} /> */}
                            <img src={logo} alt="Project Control Manager" style={{ height: '30px', width: "auto" }} />
                        </Box>
                        <IconButton onClick={handleClose} sx={(theme) => ({
                            position: "absolute",
                            right: 10,
                            top: 10,
                            backgroundColor: "transparent",
                            '&:hover': {
                                backgroundColor: 'transparent',
                            },
                            '&:focus': {
                                backgroundColor: 'transparent',
                            },
                            '&:active': {
                                backgroundColor: 'transparent',
                            },
                        })}>
                            {/* <IoMdClose style={{ fontSize: "25px" }} /> */}
                            <CrossIcon style={{ fontSize: "16px", width: "16px", height: "16px", }} />
                        </IconButton>
                    </Box>
                    <Box sx={{ padding: '10px 0px 10px 36px' }}>
                        {step === 0 ? (
                            <>
                                <Typography variant="h6" sx={{ color: '#fff', fontSize: "32px", lineHeight: "120%", letterSpacing: "-2.5px", fontWeight: "700" }}>
                                    Hello there.
                                </Typography>
                                <Typography variant="h5" sx={{ color: '#fff', fontSize: "32px", lineHeight: "120%", letterSpacing: "-2.5px", fontWeight: "700" }}>
                                    How can we help?
                                </Typography>
                            </>
                        ) : (
                            <Typography variant="h5" sx={{ color: '#fff', fontSize: "32px", lineHeight: "120%", letterSpacing: "-2.5px", fontWeight: "700" }}>
                                How can we help?
                            </Typography>
                        )}
                    </Box>
                    <Box
                        ref={listRef}
                        sx={{
                            overflowY: 'auto',
                            mx: 2,
                            mt: 1,
                            mb: 2,
                            flexGrow: 1,
                            backgroundColor: '#fff',
                            borderRadius: "10px",
                            border: '1px solid #ddd',
                            position: 'relative',
                            boxShadow: '0px 2px 8px 0px #0000000F, 0px 0px 0px 1px #00000014',
                            '&::-webkit-scrollbar': { width: '6px' },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1',
                                borderRadius: '10px',
                            },
                        }}>
                        <Box
                            sx={{
                                position: 'sticky',
                                top: 0,
                                backgroundColor: '#fff',
                                zIndex: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: "6px 20px 6px 8px"
                            }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {step > 0 && (
                                    <IconButton size="small" onClick={() => {
                                        setStep(step - 1);
                                        setInput('');
                                    }} sx={{ padding: 0 }}>
                                        {/* <ChevronLeftIcon fontSize="small" /> */}
                                        <LeftArrow style={{ height: "14px", width: "14px", fontWeight: 500, }} />
                                    </IconButton>
                                )}
                                <Typography sx={{ fontSize: "14px", lineHeight: "100%", fontWeight: "500", letterSpacing: "-1px", color: "#00000080" }}>
                                    {step === 0
                                        ? 'All Projects'
                                        : step === 1
                                            ? selectedProject?.project_name
                                            : step === 2
                                                ? selectedMainTab
                                                : selectedSubTab?.label}
                                </Typography>
                            </Box>
                            {step === 0 && (
                                <Typography sx={{ fontSize: "14px", lineHeight: "100%", fontWeight: "500", letterSpacing: "-1px", color: "#00000080" }}>
                                    {AllProjects?.data?.length || 0}
                                </Typography>
                            )}
                        </Box>
                        <List
                            sx={{
                                cursor: "pointer",
                                "& .MuiListItem-root": { padding: 0, marginBottom: "6px" },
                                "& .MuiListItem-root:hover": { backgroundColor: "transparent" },
                            }}>
                            {step === 0 && (filteredProjects.length > 0 ? (
                                filteredProjects.map((project, index) => (
                                    <ListItem
                                        key={index}
                                        button
                                        onClick={() => {
                                            setSelectedProject(project);
                                            setStep(1);
                                            setInput('')
                                        }}>
                                        <Box sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            background: "#F2F2F2",
                                            borderRadius: "8px",
                                            padding: "10px",
                                            marginX: "8px",
                                        }}>
                                            <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000" }}>
                                                {project?.project_name}
                                            </Typography>
                                            {/* <ChevronRightIcon fontSize="small" sx={{ color: "#555" }} /> */}
                                            <RightArrow style={{ height: "16px", width: "16px", fontWeight: 500, fill: "#555" }} />
                                        </Box>
                                    </ListItem>
                                ))
                            ) : (
                                <Typography sx={{ padding: 2, textAlign: 'center', color: '#999' }}>
                                    No search result found
                                </Typography>
                            ))}
                            {step === 1 && (() => {
                                if (!trimmedInput) {
                                    return modulesList.map((module, index) => (
                                        <ListItem
                                            key={index}
                                            button
                                            onClick={() => {
                                                if (module === 'Project Dashboard') {
                                                    const projectId = selectedProject?.project_id;
                                                    handleClose();
                                                    navigate(`/projects/${projectId}?type=project-landing`);
                                                }
                                                else if (module === 'My Work') {
                                                    const projectId = selectedProject?.project_id;
                                                    handleClose();
                                                    navigate(`/projects/${projectId}/my-work`);
                                                }
                                                else if (module === 'File') {
                                                    const projectId = selectedProject?.project_id;
                                                    handleClose();
                                                    navigate(`/projects/${projectId}/key-file/all-file`);
                                                }
                                                else if (module === 'Image Gallery') {
                                                    const projectId = selectedProject?.project_id;
                                                    handleClose();
                                                    navigate(`/projects/${projectId}/image-gallery/all-images`);
                                                }
                                                else {
                                                    setSelectedMainTab(module);
                                                    setStep(2);
                                                    setInput('');
                                                }
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                    background: "#F2F2F2",
                                                    borderRadius: "8px",
                                                    padding: "10px",
                                                    marginX: "8px",
                                                }}
                                            >
                                                <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000" }}>
                                                    {module}
                                                </Typography>
                                                {/* <ChevronRightIcon fontSize="small" sx={{ color: "#555" }} /> */}
                                                <RightArrow style={{ height: "16px", width: "16px", fontWeight: 500, fill: "#555" }} />
                                            </Box>
                                        </ListItem>
                                    ));
                                }
                                const results = getStep1SearchResultsWithTag(trimmedInput);
                                if (results.length === 0) {
                                    return (
                                        <Typography sx={{ padding: 2, textAlign: 'center', color: '#999' }}>
                                            No search result found
                                        </Typography>
                                    );
                                }
                                return results.flatMap((result, idx) => {
                                    if (result.type === 'qa') {
                                        const isOpen = openQuestionIndex === result.index;
                                        return [
                                            <ListItem key={`qa-${idx}`} button onClick={result.onClick}>
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        background: "#F2F2F2",
                                                        borderRadius: "8px",
                                                        padding: "10px",
                                                        marginX: "8px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000" }}>
                                                        {<strong>Q)</strong>} {result.label}
                                                    </Typography>
                                                </Box>
                                            </ListItem>,
                                            isOpen && (
                                                <ListItem key={`qa-answer-${idx}`}>
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            background: "#FFF3CD",
                                                            borderRadius: "8px",
                                                            padding: "12px",
                                                            margin: "0 8px 8px 8px",
                                                            border: '1px solid #FFEEBA',
                                                            color: '#856404',
                                                            fontSize: '14px',
                                                            whiteSpace: 'pre-line'
                                                        }}
                                                    >
                                                        {<strong>Ans:-</strong>} {selectedAnswer}
                                                    </Box>
                                                </ListItem>
                                            )
                                        ];
                                    }
                                    return (
                                        <ListItem key={`result-${idx}`} button onClick={result.onClick}>
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    background: "#F2F2F2",
                                                    borderRadius: "8px",
                                                    padding: "10px",
                                                    marginX: "8px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000" }}>
                                                    {result.label}
                                                </Typography>
                                                {/* {result.showArrow && <ChevronRightIcon fontSize="small" sx={{ color: "#555" }} />} */}
                                                {result.showArrow && <RightArrow style={{ height: "16px", width: "16px", fontWeight: 500, fill: "#555" }} />}
                                            </Box>
                                        </ListItem>
                                    );
                                });
                            })()}

                            {step === 2 && (() => {
                                if (!trimmedInput) {
                                    if (filteredSubmodules.length > 0) {
                                        return filteredSubmodules.map((option, index) => (
                                            <ListItem
                                                key={index}
                                                button
                                                onClick={() => {
                                                    setSelectedSubTab(option);
                                                    setStep(3);
                                                    setInput('');
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        background: "#F2F2F2",
                                                        borderRadius: "8px",
                                                        padding: "10px",
                                                        marginX: "8px",
                                                    }}
                                                >
                                                    <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000" }}>
                                                        {option?.label}
                                                    </Typography>
                                                </Box>
                                            </ListItem>
                                        ));
                                    }

                                    return (
                                        <Typography sx={{ padding: 2, textAlign: 'center', color: '#999' }}>
                                            No search result found
                                        </Typography>
                                    );
                                }
                                const results = getStep2SearchResultsWithTag(trimmedInput);
                                if (results.length === 0) {
                                    return (
                                        <Typography sx={{ padding: 2, textAlign: 'center', color: '#999' }}>
                                            No search result found
                                        </Typography>
                                    );
                                }
                                return results.flatMap((result, idx) => {
                                    if (result.type === 'qa') {
                                        const isOpen = openQuestionIndex === result.index;
                                        return [
                                            <ListItem key={`qa-${idx}`} button onClick={result.onClick}>
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        background: "#F2F2F2",
                                                        borderRadius: "8px",
                                                        padding: "10px",
                                                        marginX: "8px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000" }}>
                                                        <strong>Q)</strong> {result.label}
                                                    </Typography>
                                                </Box>
                                            </ListItem>,
                                            isOpen && (
                                                <ListItem key={`qa-answer-${idx}`}>
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            background: "#FFF3CD",
                                                            borderRadius: "8px",
                                                            padding: "12px",
                                                            margin: "0 8px 8px 8px",
                                                            border: '1px solid #FFEEBA',
                                                            color: '#856404',
                                                            fontSize: '14px',
                                                            whiteSpace: 'pre-line'
                                                        }}
                                                    >
                                                        <strong>Ans:-</strong> {selectedAnswer}
                                                    </Box>
                                                </ListItem>
                                            )
                                        ];
                                    }
                                    return (
                                        <ListItem key={`result-${idx}`} button onClick={result.onClick}>
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    background: "#F2F2F2",
                                                    borderRadius: "8px",
                                                    padding: "10px",
                                                    marginX: "8px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000" }}>
                                                    {result.label}
                                                </Typography>
                                            </Box>
                                        </ListItem>
                                    );
                                });
                            })()}

                            {step === 3 && (() => {
                                const results = [];
                                if (trimmedInput && selectedProject) {
                                    staticQAList.forEach((qaItem, idx) => {
                                        if (qaItem.question.toLowerCase().includes(trimmedInput)) {
                                            results.push({
                                                type: 'qa',
                                                id: `qa-${idx}`,
                                                label: qaItem.question,
                                                index: idx,
                                                onClick: () => {
                                                    setOpenQuestionIndex((prev) => (prev === idx ? null : idx));
                                                    setSelectedAnswer(qaItem.answer(selectedProject?.project_name || "Project X"));
                                                }
                                            });
                                        }
                                    });
                                }
                                const step3Filtered = filteredStep3Options
                                    .filter(option => option.toLowerCase().includes(trimmedInput))
                                    .map((option) => ({
                                        type: 'nav',
                                        label: option,
                                        onClick: () => {
                                            if (!selectedSubTab) {
                                                return;
                                            }
                                            const projectId = selectedProject?.project_id;
                                            const base = `/projects/${projectId}`;
                                            const fullUrl = option === 'Dashboard'
                                                ? `${base}${selectedSubTab?.dashboardUrl}`
                                                : `${base}${selectedSubTab?.databaseUrl}`;
                                            const tabKey = subtabsItems[selectedMainTab]?.localStorageTabKey;
                                            const tabIndex = selectedSubTab?.index;

                                            if (tabKey != null && tabIndex != null) {
                                                localStorage.setItem(tabKey, tabIndex);
                                            }
                                            handleClose();
                                            window.location.href = fullUrl;
                                        }

                                    }));

                                const combined = [...results, ...step3Filtered];

                                if (combined.length === 0) {
                                    return (
                                        <Typography sx={{ padding: 2, textAlign: 'center', color: '#999' }}>
                                            No search result found
                                        </Typography>
                                    );
                                }

                                return combined.flatMap((result, idx) => {
                                    if (result.type === 'qa') {
                                        const isOpen = openQuestionIndex === result.index;
                                        return [
                                            <ListItem key={`qa-${idx}`} button onClick={result.onClick}>
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        background: "#F2F2F2",
                                                        borderRadius: "8px",
                                                        padding: "10px",
                                                        marginX: "8px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000" }}>
                                                        <strong>Q)</strong> {result.label}
                                                    </Typography>
                                                </Box>
                                            </ListItem>,
                                            isOpen && (
                                                <ListItem key={`qa-answer-${idx}`}>
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            background: "#FFF3CD",
                                                            borderRadius: "8px",
                                                            padding: "12px",
                                                            margin: "0 8px 8px 8px",
                                                            border: '1px solid #FFEEBA',
                                                            color: '#856404',
                                                            fontSize: '14px',
                                                            whiteSpace: 'pre-line'
                                                        }}
                                                    >
                                                        <strong>Ans:-</strong> {selectedAnswer}
                                                    </Box>
                                                </ListItem>
                                            )
                                        ];
                                    }

                                    return (
                                        <ListItem key={`step3-${idx}`} button onClick={result.onClick}>
                                            <Box sx={{
                                                width: "100%",
                                                background: "#F2F2F2",
                                                borderRadius: "8px",
                                                padding: "10px",
                                                marginX: "8px",
                                            }}>
                                                <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000" }}>
                                                    {result.label}
                                                </Typography>
                                            </Box>
                                        </ListItem>
                                    );
                                });
                            })()}

                        </List>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            margin: '12px 16px 16px 16px',
                            borderTop: '1px solid #ccc',
                            borderRadius: '10px',
                            backgroundColor: '#F2F2F2',
                            justifyContent: 'space-between',
                            boxShadow: '0px 2px 8px 0px #0000000F, 0px 0px 0px 1px #00000014',
                            padding: '12px',
                            cursor: 'text'
                        }}
                    >
                        <TextField
                            fullWidth
                            variant="standard"
                            value={input}
                            onChange={e => {
                                const newValue = e.target.value;
                                setInput(newValue);
                                setOpenQuestionIndex(null);
                                setSelectedAnswer(null);
                            }}
                            placeholder="Type what you are looking for"
                            InputProps={{
                                disableUnderline: true,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {/* <IoIosSearch style={{ fontSize: "16px" }} /> */}
                                        <SearchIcon style={{ height: "16px", width: "16px", fill: "#808080", stroke: "#808080", strokeOpacity: 4 }} />
                                    </InputAdornment>
                                ),
                                endAdornment: input ? (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => {
                                                setInput('');
                                                setOpenQuestionIndex(null);
                                                setSelectedAnswer('');
                                            }}
                                            edge="end" size="small" >
                                            {/* <ClearIcon style={{ fontSize: "16px" }} /> */}
                                            <CrossIcon style={{ fontSize: "16px", width: "16px", height: "16px", fill: "#808080" }} />
                                        </IconButton>
                                    </InputAdornment>
                                ) : null,
                                style: {
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                    fontWeight: 400
                                },
                            }}
                            sx={{ backgroundColor: '#F2F2F2' }}
                        />
                    </Box>
                </Box>
            )}
        </>
    );
}